import { StyleSheetManager } from 'styled-components';
import { RouterProvider } from 'react-router-dom';
import { Suspense } from 'react';
import useI18next from './services/i18n';

import { useNetworkStatus } from 'hooks/common';
import { useSelector } from './hooks';

import { setParamsToWindow } from 'helpers/window';
import { isProd } from 'helpers/utils';
import { addQACommandsToWindow } from 'helpers/qaCommands';

import { PageLoader } from 'components/PageLoader';
import Notifications from './components/Notifications';

import ThemeProvider from './theme/provider';
import { OPEN_SUPPORT_FORM } from './store/user/actionTypes';
import { createProcessingSelector } from './store/loading/selectors';
import { EppoGate } from './services/Eppo';
import router from './router';

function App() {
    if (!isProd()) addQACommandsToWindow();

    const { isTranslationsLoaded } = useI18next();

    useNetworkStatus();

    setParamsToWindow();
    const isLoadingSupportForm = useSelector(createProcessingSelector([OPEN_SUPPORT_FORM]));

    return (
        isTranslationsLoaded && (
            <StyleSheetManager>
                <ThemeProvider>
                    <Notifications />
                    <EppoGate>
                        {isLoadingSupportForm ? (
                            <PageLoader />
                        ) : (
                            <Suspense fallback={<PageLoader />}>
                                <RouterProvider router={router} />
                            </Suspense>
                        )}
                    </EppoGate>
                </ThemeProvider>
            </StyleSheetManager>
        )
    );
}

export default App;
